import { getAxiosInstance } from "../../../../api";

export const getRemittanceInvoiceData = async (remittanceId) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(
      `/admin/remittance/invoice?remittance_id=${remittanceId}`
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
